@if (dynamicForm) {
<form [formGroup]="dynamicForm" (ngSubmit)="submitForm()">
    @for (field of fields; track field.id) {
        @switch (field.type) {
            @case ('text') {
                <div class="form-group mb-5 xl:mb-9">
                    <label [for]="'kl-field-'+field.name">{{field.label}}@if (field.required) {<sup>*</sup>}</label>
                    <input type="text" [id]="'kl-field-'+field.name"
                        [formControlName]="field.name"
                        class="form-control capitalize"
                        restrictCopyPaste input-mask="letterOnly"
                        autocomplete="off"
                        [maxlength]="getMaxLength(field)" data-type="input">
                    @if (getFieldError(field.name)) {
                        <span class="error">{{getFieldError(field.name)}}</span>
                    }
                </div>
            }
            @case ('email') {
                <div class="form-group mb-5 xl:mb-9">
                    <label [for]="'kl-field-'+field.name">{{field.label}}@if (field.required) {<sup>*</sup>}</label>
                    <input type="text" [id]="'kl-field-'+field.name"
                        [formControlName]="field.name"
                        class="form-control"
                        restrictCopyPaste input-mask="email"
                        autocomplete="off"
                        [maxlength]="getMaxLength(field)" data-type="input">
                    @if (getFieldError(field.name)) {
                        <span class="error">{{getFieldError(field.name)}}</span>
                    }
                </div>
            }
            @case ('tel') {
                <div class="form-group mb-5 xl:mb-9">
                    <label [for]="'kl-field-'+field.name">{{field.label}}@if (field.required) {<sup>*</sup>}</label>
                    <input type="text" [id]="'kl-field-'+field.name"
                        [formControlName]="field.name"
                        class="form-control"
                        restrictCopyPaste input-mask="numberOnlyStartWithFive"
                        autocomplete="off"
                        [maxlength]="getMaxLength(field)" data-type="input">
                    @if (getFieldError(field.name)) {
                        <span class="error">{{getFieldError(field.name)}}</span>
                    }
                </div>
            }
            @case ('select') {
                <div class="form-group mb-5 xl:mb-9 type-select hide">
                    <label [for]="'kl-field-'+field.name">{{field.label}}@if (field.required) {<sup>*</sup>}</label>
                    <input type="text" [id]="'kl-field-'+field.name"
                        [formControlName]="field.name"
                        class="form-control"
                        restrictCopyPaste
                        (click)="handler__selectInput($event)"
                        readonly autocomplete="off" data-type="input">
                    <div class="select-box" (click)="handler__selectBox($event)">
                        <ng-scrollbar thumbClass="custom-scrollbars">
                            <ul>
                                @for (option of field.options; track option.value) {
                                    <li (click)="handler__selectOption($event, field.name, option.value)">{{option.label}}</li>
                                }
                            </ul>
                        </ng-scrollbar>
                    </div>
                    @if (getFieldError(field.name)) {
                        <span class="error">{{getFieldError(field.name)}}</span>
                    }
                </div>
            }
            @case ('textarea') {
                <div class="form-group mb-5 xl:mb-9">
                    <label [for]="'kl-field-'+field.name">{{field.label}}@if (field.required) {<sup>*</sup>}</label>
                    <textarea [id]="'kl-field-'+field.name"
                        [formControlName]="field.name"
                        class="form-control"
                        rows="1" data-type="input"
                        autocomplete="off"
                        [maxlength]="getMaxLength(field)"></textarea>
                    @if (getFieldError(field.name)) {
                        <span class="error">{{getFieldError(field.name)}}</span>
                    }
                </div>
            }
        }
    }

    <!-- Captcha -->
    <div class="row">
        <div class="col-lg-6">
            <div class="form-group mb-5 xl:mb-9">
                <label>Enter Captcha<sup>*</sup></label>
                <input type="text" formControlName="captcha_form" maxlength="6"
                    restrictCopyPaste input-mask="numberAndText"
                    class="form-control" data-type="input">
                @if (dynamicForm.get('captcha_form')?.touched && dynamicForm.get('captcha_form')?.errors) {
                    @if (dynamicForm.get('captcha_form')?.hasError('required')) {
                        <span class="error">Please enter captcha</span>
                    }
                    @if (dynamicForm.get('captcha_form')?.hasError('minlength')) {
                        <span class="error">Please enter a valid captcha</span>
                    }
                }
            </div>
        </div>
        @if (queryCaptcha) {
            <div class="col-lg-6">
                <div class="form-group mb-5 xl:mb-9">
                    <div class="flex items-center gap-2">
                        <img [src]="queryCaptcha" alt="captcha" width="198" height="50" loading="lazy" fetchpriority="auto">
                        <img [ngSrc]="assetsCDNUrl+'/assets/images/icons/refresh-black.svg'"
                            alt="Refresh captcha" (click)="generateCaptcha()"
                            class="min-w-7 min-h-7 w-7 h-7 cursor-pointer" title="Refresh captcha"
                            width="50" height="50" loading="lazy" fetchpriority="auto">
                    </div>
                </div>
            </div>
        }
    </div>

    @if (errorMessage) {
        <div class="error mb-4">{{errorMessage}}</div>
    }

    <button type="submit" [disabled]="dynamicForm.invalid || isSubmitting"
        [class]="submitButtonClass">
        {{isSubmitting ? submittingButtonText : submitButtonText}}
    </button>
</form>
}

<app-congratulation-popup [toastMsg]="successMessage"></app-congratulation-popup>
